module.exports = __webpack_public_path__ + "img/loader.26f565a8.gif";